import React from "react";
import "./AboutPage.css";
import logo from "../assets/bg-remover-logo.png";
import { useNavigate } from "react-router-dom";
export const facilities = [
  {
    id: 1,
    name: "Basketball Courts",
    className: "basketball-court",
    slug: "basketball",
    image:
      "https://media.istockphoto.com/id/503333948/photo/basketball-court-after-the-rain.jpg?s=612x612&w=0&k=20&c=J7SlrVy24iJd5seu_JEFwqj3EYQIUfvqDH1BLhzarwI=",
    description: `Our basketball courts are designed to meet professional standards, ensuring optimal grip and bounce. 
  The flooring is made from high-quality material that minimizes injuries and enhances performance. 
  LED floodlights enable smooth gameplay even during evening sessions. 
  The courts are spacious enough to host both practice sessions and competitive tournaments. 
  Scoreboards and seating arrangements are available for players and spectators. 
  Every detail is crafted to deliver the perfect basketball experience for all age groups.`,
  },
  {
    id: 2,
    name: "Tennis Courts",
    className: "tennis-court",
    slug: "tennis",
    image:
      "https://content.jdmagicbox.com/comp/def_content/lawn-tennis-courts/xqphrway5j-lawn-tennis-courts-4-t0vt1.jpg",
    description: `Our tennis courts feature synthetic surfaces built to international standards for consistent bounce. 
  Each court is maintained regularly to ensure a smooth playing experience for athletes. 
  Proper drainage systems make the surface suitable for all weather conditions. 
  Ample lighting and boundary fencing create a safe and focused environment. 
  The courts are ideal for both recreational play and professional training. 
  Every match played here combines comfort, precision, and competitive spirit.`,
  },
  {
    id: 3,
    name: "Running Tracks",
    className: "running-track",
    slug: "running",
    image:
      "https://images.unsplash.com/photo-1612626360035-324ebf7d27f1?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fHJ1bm5pbmclMjB0cmFja3xlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=60&w=400",
    description: `Our all-weather running tracks are built with high-quality synthetic material for durability. 
  The shock-absorbent surface reduces stress on joints and supports long-distance training. 
  Lane markings are precise, helping athletes improve their speed and coordination. 
  The facility provides an ideal environment for sprints, warm-ups, and endurance practice. 
  Evening lighting ensures training can continue after sunset. 
  The track is designed to inspire athletes to push their limits safely.`,
  },
  {
    id: 4,
    name: "Football Fields",
    className: "football-field",
    slug: "football",
    image:
      "https://images.unsplash.com/photo-1556056504-5c7696c4c28d?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Zm9vdGJhbGwlMjBwaXRjaHxlbnwwfHwwfHx8MA%3D%3D&fm=jpg&q=60&w=3000",
    description: `Our football fields are laid with natural green turf that provides excellent traction. 
  Each field is well-maintained with proper boundary nets and corner markings. 
  Spacious sidelines allow smooth team coordination and player substitution. 
  Floodlights make the ground suitable for evening matches and tournaments. 
  The environment is designed to encourage teamwork, skill, and sportsmanship. 
  Every match here becomes a blend of passion, energy, and true football spirit.`,
  },
  {
    id: 5,
    name: "Volleyball Courts",
    className: "volleyball-court",
    slug: "volleyball",
    image:
      "https://static.wixstatic.com/media/5c559b_2d3b856e4d1a4f43b67e7d97280a2b96~mv2.jpg/v1/fill/w_640,h_468,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/5c559b_2d3b856e4d1a4f43b67e7d97280a2b96~mv2.jpg",
    description: `Our volleyball courts are equipped with anti-slip flooring and high-quality nets. 
  They are spacious enough for both practice sessions and official matches. 
  The boundary lines and markings meet standard measurement guidelines. 
  Surrounding space ensures player safety and free movement during play. 
  Proper illumination allows matches to continue into the evening. 
  The setup promotes energy, focus, and team coordination among athletes.`,
  },
  {
    id: 6,
    name: "Badminton Courts",
    className: "badminton-court",
    slug: "badminton",
    image:
      "https://content.jdmagicbox.com/v2/comp/hyderabad/s3/040pxx40.xx40.231201155021.e8s3/catalogue/reflex-badminton-academy-hyderabad-badminton-courts-x9srq5ypnl.jpg",
    description: `Our indoor badminton courts feature professional-grade wooden flooring with synthetic layering. 
  The anti-glare lighting ensures players have a clear view during rallies. 
  Proper ventilation maintains comfort for long-duration sessions. 
  Courts are regularly inspected for maintenance and safety standards. 
  The nets, poles, and boundaries follow international specifications. 
  This facility provides the perfect setting for beginners and professionals alike.`,
  },
];

function AboutPage() {
  const navigate = useNavigate();
  const handleClick = (name) => {
    navigate(`/courts/${name}`);
  };

  return (
    <div className="about-page">
      {/* Hero Section */}
      <section
        className="about-hero"
        style={{
          background:
            "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/assets/sport-about.jpeg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
      >
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Who We Are?</h1>
            <div className="hero-description">
              <p>
                We expertise in world-class scientific training, coaching, and
                development programs for athletes of all skill including key
                focus on Sports Meditation, Sports Psychology, Elite Fitness,
                Sports Nutrition. <br></br>With over decades of expertise,
              </p>
              <p>
                Ask Me Sports infrastructure is a major player in the field{" "}
              </p>
              <p>of indoor and outdoor sports infrastructure.</p>
              <p>
                We specialize in high-performance sports surfaces.
                <br />
                or sports infrastructure.{" "}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Sports Facilities Showcase */}
      <section className="facilities-showcase">
        <div className="container">
          <div className="facilities-grid">
            {facilities.map((data, index) => (
              <div
                className="facility-item"
                onClick={() => handleClick(data.slug)}
              >
                <div className={`facility-image ${data.className}`}>
                  <div className="facility-overlay">
                    <h4 className="facility-name">{data.name}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="expertise-section">
        <div className="container">
          <div className="expertise-content">
            <div className="expertise-text">
              <h2 className="section-title">Our Expertise</h2>
              <div className="expertise-description">
                <p>
                  We are a premier sports consultancy dedicated to nurturing
                  athlete talent and empowering future champions.Our mission is
                  to deliver world-class and scientific training programs that
                  help athletes unlock their full potential and achieve
                  greatness.
                </p>
                <p>
                  With expert coaches, advanced & scientific training program,
                  we provide the ideal environment for growth, discipline, and
                  excellence. Our key focus on Sports Meditation, Sports
                  Psychology, Elite Fitness. At Sports Alliance, we don’t just
                  train athletes — we build future champions to achieve their
                  goals.
                </p>
                <p>
                  Our experienced coaches and state-of-the-art advance coaching
                  program create the perfect environment for over all athlete
                  development. We focus on building character, discipline,
                  mental toughness and excellence in every athlete we train.
                </p>
              </div>
              <div className="expertise-stats">
                <div className="stat-item">
                  <div className="stat-number">20+</div>
                  <div className="stat-label">Years Experience</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">450+</div>
                  <div className="stat-label">Projects Completed</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">50+</div>
                  <div className="stat-label">Sports Types</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">100%</div>
                  <div className="stat-label">Client Satisfaction</div>
                </div>
              </div>
            </div>
            <div className="expertise-image">
              <div className="image-placeholder">
                <div className="placeholder-content">
                  <h3>Sports Infrastructure Excellence</h3>
                  <p>Building the future of sports</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <h2 className="section-title">Our Mission</h2>
            <p className="misson-ptag">
              {" "}
              Build the basic skills were the over all develop the champion
              mindset of athlete to under go the process which leads to achieve
              their goals <br /> to become champion at any level{" "}
            </p>
            <div className="mission-grid">
              <div className="mission-item">
                <div className="mission-icon">🎯</div>
                <h3 className="mission-title">Excellence</h3>
                <p className="mission-description">
                  We create the better way to perform with Sports Meditation,
                  Sports Psychology, Elite Fitness & Sports Coaching.
                </p>
              </div>
              <div className="mission-item">
                <div className="mission-icon">🏗️</div>
                <h3 className="mission-title">Innovation</h3>
                <p className="mission-description">
                  Develop the new theories of Scientific Training and skill full
                  methods of coaching were individual focus on athlete.
                </p>
              </div>
              <div className="mission-item">
                <div className="mission-icon">🤝</div>
                <h3 className="mission-title">Partnership</h3>
                <p className="mission-description">
                  Building long-term relationships with athletes and clients
                  through reliable service and exceptional results.
                </p>
              </div>
              <div className="mission-item">
                <div className="mission-icon">🏆</div>
                <h3 className="mission-title">Performance</h3>
                <p className="mission-description">
                  Created and crafted champions in all sports at State level,
                  National Level and International Level{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community
                building. Our comprehensive programs help athletes develop both
                physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">
                    Advanced coaching techniques for professional athletes
                  </p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">
                    Outstanding performances in the latest tournament
                  </p>
                </div>
              </div>
              <button className="view-more">View More...</button>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li>
                  <a href="/" className="footer-link">
                    HOME
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link">
                    ABOUT OUR WEBSITE
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link">
                    SHOP
                  </a>
                </li>
                <li>
                  <a href="#" className="footer-link">
                    GALLERY
                  </a>
                </li>
                <li>
                  <a href="/contact" className="footer-link">
                    CONTACT
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">
                  📍 36/B Lane no.5 dharm park shyam nagar-2 Rajasthan/Jaipur -
                  302019
                </div>
                <div className="contact-item">📞 +91-9414050348</div>
                <div className="contact-item">
                  ✉️ askmesportsalliance@gmail.com
                </div>
                <div className="contact-item">
                  🌐 www.askmesportsalliance.com
                </div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img
              src={logo}
              alt="Sports Alliance Logo"
              className="footer-logo-icon"
            />
            <span className="footer-logo-text">ASK ME SPORTS ALLIANCE</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 ASK ME SPORTS ALLIANCE. Building Future, Shaping
            Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default AboutPage;
